export default "__VITE_ASSET__B$8p7R3L__"